import { render, staticRenderFns } from "./dialogHelpFish.vue?vue&type=template&id=affc875a&scoped=true&"
import script from "./dialogHelpFish.vue?vue&type=script&lang=js&"
export * from "./dialogHelpFish.vue?vue&type=script&lang=js&"
import style0 from "./dialogHelpFish.vue?vue&type=style&index=0&id=affc875a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affc875a",
  null
  
)

export default component.exports